import Project from "./Components/Project";

export default Project;
